import * as React from 'react';
import { cn } from '@/lib/utils';

interface VyndraLogoProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  /**
   * REPEINDRE LE PRISME (mockups/connexion-hybride-mockup.html, parti pris 3
   * « le prisme » : « aile rouge pour l'informatique, aile bleue pour la
   * securite, clef de voute doree pour le groupe »). Le logo Vyndra est deja
   * fait de deux ailes et d'une clef de voute : les repeindre suffit, rien
   * n'est redessine. Repli sur le violet/cyan/beige de la marque Vyndra quand
   * aucune couleur n'est fournie : les 17 usages existants du logo restent au
   * pixel pres inchanges.
   */
  aileGauche?: string;
  aileDroite?: string;
  clef?: string;
}

/**
 * Logo Vyndra "Pixel Prism" : official brand mark.
 * Three cascading diamonds (purple left, cyan right, beige center bottom) forming a V.
 */
export function VyndraLogo({
  size = 32,
  className,
  aileGauche = '#8B5CF6',
  aileDroite = '#22D3EE',
  clef = '#D4C5A0',
  ...props
}: VyndraLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={cn('inline-block', className)}
      {...props}
    >
      <path d="M52 28 L78 48 L52 68 L26 48 Z" fill={aileGauche} opacity="0.95" />
      <path d="M60 56 L86 76 L60 96 L34 76 Z" fill={aileGauche} opacity="0.72" />
      <path d="M70 84 L96 104 L70 124 L44 104 Z" fill={aileGauche} opacity="0.5" />
      <path d="M148 28 L174 48 L148 68 L122 48 Z" fill={aileDroite} opacity="0.9" />
      <path d="M140 56 L166 76 L140 96 L114 76 Z" fill={aileDroite} opacity="0.68" />
      <path d="M130 84 L156 104 L130 124 L104 104 Z" fill={aileDroite} opacity="0.45" />
      <path d="M100 118 L120 138 L100 158 L80 138 Z" fill={clef} opacity="0.85" />
    </svg>
  );
}
